import React from 'react'
import PropTypes from 'prop-types'
import styles from './index.module.scss'
import { formatToUSD } from '../../../utilities/formatters'
import cn from 'classnames'

function SummaryCards ({ totalSales, accountsReceivable, overdueReceivables, percentOverdue }) {
  const getAmount = (amount) => {
    const temp = parseFloat(amount) ?? 0
    return temp > 0 ? `$${formatToUSD(parseFloat(temp))}` : '--'
  }

  return (
    <div className={styles.container}>
      <div className={styles.summaryRow}>
        <div className={styles.summaryCardContainer}>
          <div className={cn(styles.summaryCard, styles.totalSales)}>
            <div className={styles.summaryValue}>{getAmount(totalSales)}</div>
            <div className={styles.summaryLabel}>Total Sales</div>
          </div>
        </div>
        <div className={styles.summaryCardContainer}>
          <div className={cn(styles.summaryCard, styles.accountsReceivable)}>
            <div className={styles.summaryValue}>{getAmount(accountsReceivable)}</div>
            <div className={styles.summaryLabel}>Accounts Receivables</div>
          </div>
        </div>
      </div>
      <div className={styles.summaryRow}>
        <div className={styles.summaryCardContainer}>
          <div className={cn(styles.summaryCard, styles.overdueReceivables)}>
            <div className={styles.summaryValue}>{getAmount(overdueReceivables)}</div>
            <div className={styles.summaryLabel}>Overdue Receivables</div>
          </div>
        </div>
        <div className={styles.summaryCardContainer}>
          <div className={cn(styles.summaryCard, styles.overduePercent)}>
            <div className={styles.summaryValue}>{`${percentOverdue ? `${percentOverdue.toFixed(2)}%` : '--'}`}</div>
            <div className={styles.summaryLabel}>% Overdue</div>
          </div>
        </div>
      </div>
    </div>
  )
}

SummaryCards.propTypes = {
  totalSales: PropTypes.number.isRequired,
  accountsReceivable: PropTypes.number.isRequired,
  overdueReceivables: PropTypes.number.isRequired,
  percentOverdue: PropTypes.number.isRequired,
  overdueGauge: PropTypes.number.isRequired
}

export default SummaryCards
